import { BUITheme } from "@blofin/blofin-ui";
import { cva } from "class-variance-authority";

const colors = cva(
  'after:content-[""] after:w-[32px] after:h-[2px] after:block after:mt-[6px] after:mx-auto after:mb-[0px]',
  {
    variants: {
      theme: {
        light: "text-light-label after:bg-light-primary border-light-line",
        dark: "text-dark-label after:bg-dark-primary border-dark-line"
      }
    }
  }
);

const titleStyles = (props: { theme: BUITheme; active: "active" | null }) => {
  const { theme } = props;

  return cva("leading-[24px] cursor-pointer font-normal text-[16px", {
    variants: {
      active: {
        active: colors({ theme })
      }
    }
  })(props);
};

const textStyles = cva("", {
  variants: {
    theme: {
      light: "text-light-label-40",
      dark: "text-dark-label-40"
    }
  }
});

const activeStyles = cva("", {
  variants: {
    theme: {
      light: "text-light-primary",
      dark: "text-dark-primary"
    }
  }
});

const itemStyles = cva("w-full leading-[40px] px-3 rounded-[8px] ", {
  variants: {
    theme: {
      light: "hover:bg-light-fill-secondary text-light-label",
      dark: "hover:bg-dark-hover-fill-secondary text-dark-label"
    }
  }
});

const borderStyles = cva("", {
  variants: {
    theme: {
      light: "border-light-line-primary",
      dark: "border-dark-line-primary"
    }
  }
});

export { titleStyles, itemStyles, textStyles, activeStyles, borderStyles };
